// extracted by mini-css-extract-plugin
export default {"navbarContainer":"navbar_navbarContainer__XPpFF","appName":"navbar_appName__+RsfN","navLinks":"navbar_navLinks__F4u7q","logo_name":"navbar_logo_name__ZiKEe"};